export default __webpack_public_path__ + "static/media/refund.9a8ec73a.png";